<template>
    <div v-click-outside="closeDialog" class="vue-month-selector-input-container">
        <div @click="openDialog" class="vue-month-selector-slot-container">
            <slot :month-name="name"></slot>
        </div>
        <div class="vue-month-selector-input-component-container">
            <v-month-picker v-model="value" :months="months" @change="change" v-if="isDialogOpened()" @change-month-name="changeMonthName"></v-month-picker>
        </div>
    </div>
</template>
<style>
    .vue-month-selector-input-container {
        position: relative;
    }
    .vue-month-selector-slot-container {
        display: inline-block;
    }
    .vue-month-selector-input-component-container {
        position: absolute;
        z-index: 1000;
    }
</style>
<script>
    import VMonthPicker from './v-month-picker';
    import ClickOutside from 'vue-click-outside';
    import props from './props.js';
    import MonthNameHelper from './utils/MonthNameHelper';
    import MonthNormalizer from "./utils/MonthNormalizer";

    export default {
        components: {
            VMonthPicker
        },
        props: props,
        data() {
            return {
                dialogOpened: false,
                name: ''
            };
        },
        directives: {
            ClickOutside
        },
        mounted() {
            this.popupItem = this.$el
        },
        created() {
            MonthNormalizer.normalize(this.value);
            this.changeMonthName(MonthNameHelper.getMonthName(this.months, this.value));
        },
        methods: {
            openDialog() {
                this.dialogOpened = true;
            },
            closeDialog() {
                this.dialogOpened = false;
            },
            isDialogOpened() {
                return this.dialogOpened;
            },
            changeMonthName(name) {
                this.name = name;
                this.$emit('change-month-name', name);
            },
            change(month) {
                this.$emit('change', month);
                this.$emit('input', month);
                this.changeMonthName(MonthNameHelper.getMonthName(this.months, this.value));
                this.closeDialog();
            }
        }
    }
</script>